/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import {
    onKeyBackTemporaryGuideIssueOverlay,
    onKeyOkTemporaryGuideIssueOverlay,
    onMouseClickTemporaryGuideIssueOverlay,
} from '../../overlay/temporaryguideissueoverlay/temporaryguideissueoverlay.reducers';
import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import {
    onKeyBackChannelOptionsOverlay,
    onKeyOkChannelOptionsOverlay,
    onKeyPlayChannelOptionsOverlay,
    onMouseClickChannelOptionsOverlay,
} from '../../overlay/channeloptionsoverlay/channeloptionsoverlay.reducers';
import {
    onKeyDownGuideOperations,
    onKeyLeftGuideOperations,
    onKeyOkGuideOperations,
    onKeyRightGuideOperations,
    onKeyUpGuideOperations,
    onKeyBackGuideOperations,
    onKeyDigitGuideOperations,
    onKeyDashGuideOperations,
    onLongKeyOkGuideOperations,
    onKeyPlayGuideOperations,
    onKeyInfoGuideOperations,
    cancelGuideSpinnerOperations,
} from './guidekeyoperations.reducers';
import { onKeyOkEnterChannelNumber } from '../enterchannelnumber/enterchannelnumber.reducers';
import {
    onKeyBackNoNetworkOverlay,
    onKeyOkNoNetworkOverlay,
    onMouseClickNoNetworkOverlay,
} from '../../overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import { showSettingsScreen } from '../../screens/screens.reducers';
import { loadGridGuideNextChannels, loadGridGuidePreviousChannels } from '../guide.reducers';
import {
    onMouseClickGuideInteractiveLayerOperations,
    onMouseClickGuideOperations,
    onMouseOkLongPressStartGuideOperations,
    onMouseOkLongPressStartInteractiveLayerOperations,
    onMouseOkLongPressStopInteractiveLayerOperations,
    onMouseOutGuideOperations,
    onMouseOverGuideOperations,
    onMouseWheelGuideOperations,
} from './guidemouseoperations.reducers';
import {
    hideOverlayDialog,
    onKeyDownOverlayDialaog,
    onKeyLeftOverlayDialog,
    onKeyRightOverlayDialog,
    onKeyUpOverlayDialog,
    onMouseOutOverlayDialogOperations,
    onMouseOverOverlayDialogOperations,
} from '../../overlaydialog/overlaydialog.reducers';
import {
    onKeyBackExitConfirmationOverlay,
    onKeyOkExitConfirmationOverlay,
    onMouseClickExitConfirmationOverlay,
} from '../../overlay/exitconfirmationoverlay/exitconfirmationoverlay.reducers';
import {
    onKeyBackRecordOverlay,
    onKeyOkRecordOverlay,
    onKeyPlayRecordOverlay,
    onMouseClickRecordOverlay,
} from '../../overlay/recordoverlay/recordoverlay.reducers';
import {
    onKeyBackVodResumeStartOverOverlay,
    onKeyOkVodResumeStartOverOverlay,
    onMouseClickVodResumeStartOverOverlay,
} from '../../overlay/vodresumestartoveroverlay/vodresumestartoveroverlay.reducers';
import {
    onKeyBackSocuErrorOverlay,
    onKeyOkSocuErrorOverlay,
    onMouseClickSocuErrorOverlay,
} from '../../overlay/socuerroroverlay/socuerroroverlay.reducres';
import { startGuidePageScroll, startTurboScroll } from '../turboscroll/turboscroll.reducers';

export const onKeyBackGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyBackGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyBackChannelOptionsOverlay());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyBackGuideOperations());
            break;

        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
            dispatch(onKeyBackTemporaryGuideIssueOverlay());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyBackExitConfirmationOverlay());
            break;
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyBackNoNetworkOverlay());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            dispatch(onKeyBackRecordOverlay());
            break;
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
            dispatch(onKeyBackSocuErrorOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyBackVodResumeStartOverOverlay());
            break;

        default:
    }
};

export const onKeyRightGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyRightGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyRightOverlayDialog());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyRightGuideOperations());
            break;

        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
            break;

        default:
    }
};

export const onKeyLeftGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyLeftGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyLeftOverlayDialog());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyLeftGuideOperations());
            break;

        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
            break;

        default:
    }
};

export const onKeyDownGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyDownGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyDownOverlayDialaog());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyDownGuideOperations());
            break;

        default:
    }
};

export const onKeyUpGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyUpGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyUpOverlayDialog());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyUpGuideOperations());
            break;

        default:
    }
};

export const onKeyOkGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyOkGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyOkChannelOptionsOverlay());
            break;

        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
            dispatch(onKeyOkTemporaryGuideIssueOverlay());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyOkExitConfirmationOverlay());
            break;
        case ScreenTaskControllerTypes.ENTER_CHANNEL_NUMBER:
            dispatch(onKeyOkEnterChannelNumber());
            break;
        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyOkGuideOperations());
            break;
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyOkNoNetworkOverlay());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            dispatch(onKeyOkRecordOverlay());
            break;
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
            dispatch(onKeyOkSocuErrorOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyOkVodResumeStartOverOverlay());
            break;

        default:
    }
};

export const onKeyPlayGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyPlayGuideOperations());
            break;
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onKeyPlayChannelOptionsOverlay());
            break;
        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onKeyPlayGuideOperations());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            dispatch(onKeyPlayRecordOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyOkVodResumeStartOverOverlay());
            break;

        default:
    }
};

export const onKeyPlayPauseGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            // If additional task needs to be performed at this point then create a reducer function
            // in channeloptionsoverlay.reducers as onKeyPlayPauseChannelOptionsOverlay.
            // For the time being using onKeyPlayChannelOptionsOverlay which serves the same purpose
            dispatch(onKeyPlayChannelOptionsOverlay());
            break;
        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            // If additional task needs to be performed at this point then create a reducer function
            // in recordoverlay.reducers as onKeyPlayPauseRecordOverlay.
            // For the time being using onKeyPlayRecordOverlay which serves the same purpose
            dispatch(onKeyPlayRecordOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onKeyOkVodResumeStartOverOverlay());
            break;

        default:
    }
};

export const onKeyDigitGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(hideOverlayDialog());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            break;

        default:
    }
    dispatch(onKeyDigitGuideOperations());
};

export const onKeyDashGuide = () => (dispatch: Function) => {
    dispatch(onKeyDashGuideOperations());
};

export const onKeyColorBlueGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(showSettingsScreen());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(showSettingsScreen());
            break;

        default:
    }
};

export const onKeyChannelDownGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(loadGridGuideNextChannels());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(loadGridGuideNextChannels());
            break;

        default:
    }
};

export const onKeyChannelUpGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(loadGridGuidePreviousChannels());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(loadGridGuidePreviousChannels());
            break;

        default:
    }
};

export const onKeyInfoGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onKeyInfoGuideOperations());
            break;
        default:
    }
};

export const onMouseClickGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.GUIDE_INTERACTIVE_LAYER_TASKS:
            dispatch(onMouseClickGuideInteractiveLayerOperations());
            break;
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onMouseClickGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
            dispatch(onMouseClickChannelOptionsOverlay());
            break;

        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onMouseClickExitConfirmationOverlay());
            break;

        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
            dispatch(onMouseClickTemporaryGuideIssueOverlay());
            break;
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onMouseClickNoNetworkOverlay());
            break;
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
            dispatch(onMouseClickRecordOverlay());
            break;
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
            dispatch(onMouseClickSocuErrorOverlay());
            break;
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onMouseClickVodResumeStartOverOverlay());
            break;

        default:
            break;
    }
};

export const onMouseOkLongPressStartGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.GUIDE_INTERACTIVE_LAYER_TASKS:
            dispatch(onMouseOkLongPressStartInteractiveLayerOperations());
            break;
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onMouseOkLongPressStartGuideOperations());
            break;
        default:
    }
};

export const onMouseOkLongPressStopGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.GUIDE_INTERACTIVE_LAYER_TASKS:
            dispatch(onMouseOkLongPressStopInteractiveLayerOperations());
            break;
        default:
    }
};

export const onMouseOverGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onMouseOverGuideOperations());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onMouseOverOverlayDialogOperations());
            break;

        default:
    }
};

export const onMouseOutGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.GUIDE_INTERACTIVE_LAYER_TASKS:
            dispatch(onMouseOutGuideOperations());
            break;
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
        case ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY:
        case ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.VOD_RESUME_START_OVER_OVERLAY_TASKS:
            dispatch(onMouseOutOverlayDialogOperations());
            break;
        default:
    }
};

export const onMouseWheelGuide =
    (wheelDeltaY: number) => (dispatch: Function, getState: Function) => {
        const { screenTaskController } = getState().screens;

        switch (screenTaskController) {
            case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
                dispatch(onMouseWheelGuideOperations(wheelDeltaY));
                break;
            default:
        }
    };

export const onLongKeyChannelDownStartGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(startGuidePageScroll());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(startGuidePageScroll());
            break;

        default:
    }
};

export const onLongKeyChannelUpStartGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(startGuidePageScroll(true));
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(startGuidePageScroll(true));
            break;

        default:
    }
};

export const onLongKeyDownStartGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(startTurboScroll());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(startTurboScroll());
            break;

        default:
    }
};

export const onLongKeyUpStartGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(startTurboScroll(true));
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(startTurboScroll(true));
            break;

        default:
    }
};

export const onLongKeyOkGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(onLongKeyOkGuideOperations());
            break;

        case ScreenTaskControllerTypes.GUIDE_SPINNER_TASKS:
            dispatch(cancelGuideSpinnerOperations());
            dispatch(onLongKeyOkGuideOperations());
            break;

        default:
    }
};
